import { render, staticRenderFns } from "./Idtel.vue?vue&type=template&id=bfd7ddee"
import script from "./Idtel.vue?vue&type=script&lang=js"
export * from "./Idtel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports